import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

interface ICompareDataTable {
  hasTitle: boolean;
  header: string;
  isImg: boolean;
  isBrandLogo: boolean;
  fillContent: string;
  addComma: boolean;
  isSummary: boolean;
  isPrice: boolean;
}

@Component({
  selector: 'lib-web-shared-ui-lib-compare-table',
  imports: [CommonModule, MatButtonModule],
  templateUrl: './lib-compare-table.component.html',
  styleUrl: './lib-compare-table.component.scss',
})
export class LibCompareTableComponent {
  @Input() set productCompareList(product: any) {
    this.loggingService.warn('@@@ INPUT | product', product());
    this.productData = product;
    this.buildDataTable(product);
  }
  @Output() detailClick = new EventEmitter();
  @Output() deleteClick = new EventEmitter();

  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();

  productData = signal<any>([]);
  defaultDataTable = signal<ICompareDataTable[]>([]);

  buildDataTable(productData: any) {
    this.loggingService.warn('@@@ Functions | buildDataTable @@@', productData);
    const currentData = this.defaultDataTable();
    // Loop For Create Row
    for (let index = 0; index < 15; index++) {
      let objData = {} as ICompareDataTable;
      switch (index) {
        case 0:
          objData = {
            hasTitle: false,
            header: '',
            isImg: true,
            isBrandLogo: false,
            fillContent: 'image_a',
            addComma: false,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 1:
          objData = {
            hasTitle: true,
            header: 'ราคา',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'price',
            addComma: true,
            isSummary: false,
            isPrice: true,
          };
          break;
        case 2:
          objData = {
            hasTitle: true,
            header: 'ยี่ห้อยาง',
            isImg: true,
            isBrandLogo: true,
            fillContent: 'brand_image',
            addComma: false,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 3:
          objData = {
            hasTitle: true,
            header: 'รุ่นยาง',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'product_model',
            addComma: false,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 4:
          objData = {
            hasTitle: true,
            header: 'ประเภทยาง',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'attr_type',
            addComma: false,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 5:
          objData = {
            hasTitle: true,
            header: 'การยึดเกาะบนถนนแห้ง',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_a',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 6:
          objData = {
            hasTitle: true,
            header: 'การยึดเกาะบนถนนเปียก',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_b',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 7:
          objData = {
            hasTitle: true,
            header: 'อายุการใช้งาน',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_c',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 8:
          objData = {
            hasTitle: true,
            header: 'ความนุ่มนวล',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_d',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 9:
          objData = {
            hasTitle: true,
            header: 'ความเงียบในห้องโดยสาร',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_e',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 10:
          objData = {
            hasTitle: true,
            header: 'ความต้านทานการหมุน',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_f',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 11:
          objData = {
            hasTitle: true,
            header: 'แรงกรุยบนถนนขรุขระ',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_g',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 12:
          objData = {
            hasTitle: true,
            header: 'การหยุดรถ',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_h',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 13:
          objData = {
            hasTitle: true,
            header: 'ลายดอกยาง(ดุดัน)',
            isImg: false,
            isBrandLogo: false,
            fillContent: 'perf_i',
            addComma: true,
            isSummary: false,
            isPrice: false,
          };
          break;
        case 14:
          objData = {
            hasTitle: false,
            header: '',
            isImg: false,
            isBrandLogo: false,
            fillContent: '',
            addComma: false,
            isSummary: true,
            isPrice: false,
          };
          break;
        default:
          break;
      }

      currentData.push(objData);
    }
    this.loggingService.error('@@@ cell data @@@', currentData);
    this.defaultDataTable.set(currentData);
  }

  btnDetailClick(productId: string) {
    this.detailClick.emit(productId);
  }

  btnDeleteClick(productId: string) {
    this.deleteClick.emit(productId);
  }
}
